import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/admin/DealerPreview";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/dealer/$userId/preview/")({
  head: ({ params }) => routeHead("/admin/dealer/$userId/preview/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
